/* eslint-disable max-len */
export const HOUSING_RIGHTS_URL = 'https://www.housingadviceni.org/advice-private-tenants/letting-fees';
export const EXPERIAN_URL =
  'https://www.awin1.com/cread.php?awinmid=7716&awinaffid=699049&ued=https%3A%2F%2Fad.doubleclick.net%2Fddm%2Fclk%2F312559079%3B274359501%3Bm%3Fhttps%3A%2F%2Fwww.experian.co.uk%2Fexperian-account%2F01_free_score.html%3F';
export const REVENUE_IE_URL = 'https://www.revenue.ie';
export const GOV_UK_URL = 'https://www.gov.uk/stamp-duty-land-tax/residential-property-rates';
